export const blockIconsHomeBlindsClosed = (
	<span className='material-symbols-outlined'>blinds_closed</span>
);
